import { useEffect, useState } from "react";
import TabsComponent from "src/components/tabs-component/tabs-component";
import EditPersonalDetails from "./components/edit-personal-details/edit-personal-details";
import EditProfessionalDetails from "./components/edit-professional-details/edit-professional-details";
import EditCommunication from "./components/edit-communication/edit-communication";
import EditFinancial from "./components/edit-financial/edit-financial";
import EditCrs from "./components/edit-crs/edit-crs";
import AddEditDocument from "./components/add-edit-document/add-edit-document";
import EditBanks from "./components/edit-banks/edit-banks";
import { LOADING } from "src/store/actions";
import { useDispatch } from "react-redux";
import instance from "src/store/axios";
import { AxiosResponse } from "axios";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import toast from "react-hot-toast";
import BreadcrumbComponent from "src/components/breadcrumb-component/breadcrumb-component";
import CustomModal from "src/components/custom-modal/custom-modal";
import DeleteModal from "src/components/delete-modal/delete-modal";
import Dashboard from "./components/dashboard/dashboard";
import DashboardProvider from "src/context/dashboard-provider";

const NewKycPage = () => {
  const { accountId, activeKyc } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const isApproveCase = queryParams.get("approve");

  const [activeTab, setActiveTab] = useState("2");
  const [accountDetails, setAccountDetails] = useState<any>();
  const [standingData, setStandingData] = useState<any>();
  const [countriesData, setCountriesData] = useState([]);
  const [openApproveModal, setOpenApproveModal] = useState<boolean>(false);
  const [documents, setDocuments] = useState<any>([]);

  useEffect(() => {
    async function prepareData() {
      dispatch({ type: LOADING, payload: true });

      await getStandindData();
      await getCountriesData();
      await getKycApi();
      dispatch({ type: LOADING, payload: false });
    }


    prepareData();
  }, []);

  useEffect(() => {
    if (accountDetails?.accountStatus?.description === "Pending") {
      getDocumentsApi();
    }
  }, [accountDetails]);

  const getKycApi = async (): Promise<void> => {
    try {
      const response: AxiosResponse<any> = await instance.get(
        `/${process.env.REACT_APP_ENDPOINT_VERSION}/account/${accountId}?kycId=${activeKyc}`
      );
      setAccountDetails(response.data.data);
    } catch (error: any) {
      if (error?.response?.status !== 401) {
        toast.error(error?.response?.data?.message || "An error occurred");
      }
      localStorage.setItem(
        "star_prev_url",
        `/account-details/${accountId}/${activeKyc}/edit`
      );
    }
  };

  const getStandindData = async (): Promise<void> => {
    try {
      const response: AxiosResponse<any> = await instance.get(
        `/${process.env.REACT_APP_ENDPOINT_VERSION}/option/standing-data`
      );
      setStandingData(response.data.data);
    } catch (error: any) {
      if (error?.response?.status !== 401) {
        toast.error(error?.response?.data?.message || "An error occurred");
      }
      localStorage.setItem(
        "star_prev_url",
        `/account-details/${accountId}/${activeKyc}/edit`
      );
    }
  };

  const getCountriesData = async (): Promise<void> => {
    try {
      const response: AxiosResponse<any> = await instance.get(
        `/${process.env.REACT_APP_ENDPOINT_VERSION
        }/option/countries?partial=${1}`
      );
      setCountriesData(response.data.data);
    } catch (error: any) {
      if (error?.response?.status !== 401) {
        toast.error(error?.response?.data?.message || "An error occurred");
      }
      localStorage.setItem(
        "star_prev_url",
        `/account-details/${accountId}/${activeKyc}/edit`
      );
    }
  };

  const handleApproveAccount = async (): Promise<void> => {
    dispatch({ type: LOADING, payload: true });
    try {
      await instance.post(
        `/${process.env.REACT_APP_ENDPOINT_VERSION}/account/${accountId}/approve/saudi`
      );
      toast.success("Account approved successfully");
      setOpenApproveModal(false);
      navigate("/home/customers-list");
    } catch (error: any) {
      if (error?.response?.status !== 401) {
        toast.error(error?.response?.data?.message || "An error occurred");
      }
    }
    dispatch({ type: LOADING, payload: false });
  };

  const getDocumentsApi = async (): Promise<void> => {
    dispatch({ type: LOADING, payload: true });

    try {
      const documentId = isApproveCase
        ? accountDetails?.pendingDocumentsId
        : accountDetails?.activeDocumentsId ||
        accountDetails?.pendingDocumentsId;

      const response = await instance.get(
        `/${process.env.REACT_APP_ENDPOINT_VERSION}/files/account/${accountDetails?.id}?accountDocumentId=${documentId}`
      );

      setDocuments(response.data);
    } catch (error: any) {
      if (error?.response?.status !== 401) {
        toast.error(error?.response?.data?.message || "An error occurred");
      }
    }

    dispatch({ type: LOADING, payload: false });
  };

  let items: any = [
    {
      key: "0",
      label: `Dashboard`,
      children: (
        <DashboardProvider>
          <Dashboard
          />
        </DashboardProvider>
      ),
    },
    {
      key: "2",
      label: `Client Information`,
      children: (
        <EditPersonalDetails
          countriesData={countriesData}
          standingData={standingData}
          accountDetails={accountDetails}
          onSuccess={() => {
            dispatch({ type: LOADING, payload: true });
            getKycApi();
            setActiveTab("3");
            dispatch({ type: LOADING, payload: false });
          }}
        />
      ),
    },
    {
      key: "3",
      label: `Professional details`,
      children: (
        <EditProfessionalDetails
          standingData={standingData}
          accountDetails={accountDetails}
          onSuccess={() => {
            dispatch({ type: LOADING, payload: true });
            getKycApi();
            setActiveTab("4");
            dispatch({ type: LOADING, payload: false });
          }}
        />
      ),
      disabled: !accountDetails?.accountInfo[0]?.titleId,
    },
    {
      key: "4",
      label: `Communication address`,
      children: (
        <EditCommunication
          accountDetails={accountDetails}
          onSuccess={() => {
            dispatch({ type: LOADING, payload: true });
            getKycApi();
            setActiveTab("6");
            dispatch({ type: LOADING, payload: false });
          }}
        />
      ),
      disabled: !accountDetails?.accountInfo[0]?.employmentStatusId,
    },
    // {
    //   key: "5",
    //   label: `Preferences`,
    //   children: <EditPreference />,
    // },
    {
      key: "6",
      label: `Financial details`,
      children: (
        <EditFinancial
          accountDetails={accountDetails}
          onSuccess={() => {
            dispatch({ type: LOADING, payload: true });
            getKycApi();
            setActiveTab("7");
            dispatch({ type: LOADING, payload: false });
          }}
        />
      ),
      disabled: !accountDetails?.accountInfo[0]?.mobileNumber,
    },
    {
      key: "7",
      label: `Banks`,
      children: (
        <EditBanks
          onSuccess={() => {
            dispatch({ type: LOADING, payload: true });
            getKycApi();
            // setActiveTab("8");
            dispatch({ type: LOADING, payload: false });
          }}
        />
      ),
    },
    {
      key: "8",
      label: `FATCA & CRS`,
      children: <EditCrs
        onSuccess={() => {
          dispatch({ type: LOADING, payload: true });
          getKycApi();
          setActiveTab("1");
          dispatch({ type: LOADING, payload: false });
        }}
      />,
      disabled: !accountDetails?.accountInfo[0]?.investmentExpId,
    },
    {
      key: "1",
      label: `Documents`,
      children: (
        <AddEditDocument
          standingData={standingData}
          accountKycDetails={accountDetails}
        />
      ),
    },
  ];

  const onTabChange = (key: string) => {
    setActiveTab(key);
  };

  return (
    <div className="flex flex-col gap-5 ">
      <div className="flex items-center justify-between">
        <BreadcrumbComponent />
        {accountDetails?.accountStatus?.description === "Pending" && documents?.length > 0 && (<div className="flex items-center gap-3">
          <button
            type="button"
            onClick={() => navigate("/home/customers-list")}
            className="rounded-lg bg-white px-8 py-2 text-center outline-0 cursor-pointer text-sm font-semibold border-[1px] border-blue-500 text-blue-500 hover:bg-blue-50 transition-colors"
          >
            Close
          </button>

          <button
            type="button"
            onClick={() => setOpenApproveModal(true)}
            className="rounded-lg bg-blue-500 px-4 py-2 text-center outline-0 cursor-pointer text-sm font-semibold border-2 border-blue-500 text-white transition-colors"
          >
            Approve
          </button>

        </div>)}
      </div>
      <div className="flex flex-col gap-5 bg-white rounded-lg p-5">

        <TabsComponent
          items={items}
          activeTab={activeTab}
          onChange={onTabChange}
        />
      </div>

      {/* Approve Confirmation Modal */}
      <CustomModal
        isVisible={openApproveModal}
        centered
        width={450}
        onClose={() => setOpenApproveModal(false)}
        className="delete-modal"
      >
        <DeleteModal
          onCancel={() => setOpenApproveModal(false)}
          onConfirm={handleApproveAccount}
          text="Approve Account"
          subText="Are you sure you want to approve this account?"
          icon="/images/approve-icon.svg"
        />
      </CustomModal>
    </div>
  );
};

export default NewKycPage;
